import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import Select from "react-select";
import UserRoles from "../../constants/UserRoles";


export default class IdleTask extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Recurring_Tasks._name);
	}

	handleRoles = async (value) => {
		let roles_array = [];
		if (value) {
			for (let i = 0; i < value.length; i++) {
				roles_array.push(value[i]);
			}
			this.setState({roles_array})

		} else {
			this.setState({roles_array: []})
		}
	}

	loadSelfAfterAlways() {
		if (this.state.pkey && this.state.roles_array && !Array.isArray(this.state.roles_array)) {
			//roles_array is just an array of names so we need to match them with the userroles
			let roles = JSON.parse(this.state.roles_array);
			const roles_array = [];
			for (const roleName of roles) {
				roles_array.push({value: UserRoles[roleName], label: roleName})
			}
			this.setState({roles_array})
		}
	};

	handleSubmit = async (event) => {
		if (!this.state.pkey) {
			this.state.active = true;
		}
		if (Array.isArray(this.state.roles_array)) {
			this.state.roles_array = JSON.stringify(this.state.roles_array.map((item) => item.label))
		}
		await super.handleSubmit(event, false, false)
	}

	form = () => {
		let {properties} = this.model;
		let object = this.state;
		let {loading} = this.state;
		const roles_array = !!object.roles_array ? Array.isArray(object.roles_array) ? object.roles_array : JSON.parse(object.roles_array) : [];
		console.log('WTF', roles_array)

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-6"}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.title}
									value={object.title}
									error={object.title_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Title'}
								/>
							</div>
						</div>
						<div className={"col-6"}>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.link}
									value={object.link}
									error={object.link_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Link'}
								/>
							</div>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-12"} style={{zIndex: 999}}>
							<div className="form-group">
								<Select
									key={roles_array}
									placeholder={"Department Select (Empty for All Departments)"}
									isMulti
									isClearable
									value={roles_array.map(role => {
										return (
											{value: role.value, label: role.label})
									})}
									onChange={this.handleRoles}
									options={this.props.allowed_roles.map(role_value => {
										const role = UserRoles[role_value];
										return (
											{value: role_value, label: role})
									})}
								/>
							</div>
						</div>
					</div>
					{/*<div className={"row"}>*/}
					{/*	<div className={"col-12"}>*/}
					{/*		<div className="form-group">*/}
					{/*			<Framework.Elements.TextField*/}
					{/*				property={properties.description}*/}
					{/*				value={object.description}*/}
					{/*				error={object.description_error}*/}
					{/*				update={this.handleTextFieldPropertyUpdate}*/}
					{/*				label={'Description'}*/}
					{/*				multiline={4}*/}
					{/*			/>*/}
					{/*		</div>*/}
					{/*	</div>*/}
					{/*</div>*/}
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/></div>

		)
	}
}
